export default "__VITE_ASSET__DnkcDlOm__"